import React, { useState} from "react";
import { useSelector } from "react-redux";
import { Container, Modal } from "react-bootstrap";
import axios from "axios";
import urlBackEnd from "../services/authServices";
import Cookies from "universal-cookie";
import { Button, Form, FormGroup, Label, Input, Col, Row } from "reactstrap";
import "../styles/formatsupport.css";
import ReportService from "./ReportService";

var qs = require("qs");

const FormatSupport = () => {
  const user = useSelector((state) => state.user.name);
  const [service, setService] = useState({
    clientName: "",
    phone: null,
    email: "",
    address: "",
    serviceName: "",
    subjectEmail: "Servicio Tecnico" ,
    description: "",
    created: "",
    technician: user,
    signature: "",
  });


  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  // const sigCanvasRef = useRef();

  const handleChange = (e) => {
    setService({
      ...service,
      [e.target.name]: e.target.value,
    });
  };  
  const handleSubmit = (e) => {
    e.preventDefault();
    let config = {
      method: "POST",
      url: urlBackEnd.servUrl,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: qs.stringify(service),
    };
    axios(config)
      .then(function (response) {
        return JSON.stringify(response.data);
      })
      .then((response) => {
        const serviceRecord = JSON.parse(response);
        console.log(serviceRecord)

if (serviceRecord.success) {
  console.log("Email sent: mensaje recibido");
  alert("formato de Soporte  registrado y enviado")
  
} else {
  console.log("Email not sent: mensaje no recibido");
}
      })
      .catch(function (error) {
        console.log(error);
        alert("Error de Conexión");
      });
  };

  const cookies = new Cookies(); 

  const token = cookies.get("token");
  if (token === undefined) {
    window.location.href = "/";
  } else {
    return (
      <Container fluid="xs" className="containerServ">
          <h2>Formato de Soporte</h2>
          <div className="card mb-3">
            <div className="card-body">
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="cliente">Cliente</Label>
                      <Input
                        type="text"
                        id="cliente"
                        name="clientName"
                        value={service.clientName}
                        onChange={handleChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="created">Fecha</Label>
                      <Input
                        type="date"
                        id="created"
                        name="created"
                        value={service.created}
                        onChange={handleChange}
                        />
                    </FormGroup>
                    <FormGroup>
                      <Label for="phone">Teléfono</Label>
                      <Input
                        type="text"
                        id="phone"
                        name="phone"
                        value={service.phone || ""}
                        onChange={handleChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="address">Dirección</Label>
                      <Input
                        type="text"
                        id="address"
                        name="address"
                        value={service.address}
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="email">Email</Label>
                      <Input
                        type="email"
                        id="email"
                        name="email"
                        value={service.email}
                        onChange={handleChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="service">Tipo de Servicio</Label>
                      <Input
                        type="select"
                        id="service"
                        name="serviceName"
                        value={service.serviceName}
                        onChange={handleChange}
                      >
                        <option value="">Seleccione un servicio</option>
                        <option value="Instalacion y Montaje">
                          Instalacion y montaje 
                        </option>
                        <option value="Reparación">Reparación</option>
                        <option value="Reinstalación de OS">
                          Reinstalación de OS
                        </option>
                        <option value="Reconstrucción">Reconstrucción</option>
                        <option value="Reparaciones Electrónicas">
                          Reparaciones Electrónicas
                        </option>
                        <option value="Reparación de citofonía">
                          Reparación de citofonía
                        </option>
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Label for="description">Descripción</Label>
                      <Input
                        type="textarea"
                        id="description"
                        name="description"
                        value={service.description}
                        onChange={handleChange}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <hr />
                <Button className="outline-primary" type="submit" color="info" onClick={handleSubmit}>
                  Registrar
                </Button>{" "}
                <Button
                className="outline-primary"
                  type="button"
                  color="info"
                  onClick={handleOpenModal}
                >
                  Ver
                </Button>
                <Modal show={showModal} onHide={handleCloseModal}>
                  <Modal.Header closeButton>
                    <Modal.Title>Formato de Soporte Tecnico</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <ReportService service={service}/>
                  </Modal.Body>
                </Modal>
              </Form>
            </div>
          </div>

      </Container>
    );
  }
};

export default FormatSupport;
